import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import useTopicQuestions from "../../hooks/useTopicQuestionsNew";
import { Scale } from 'react-scaling';


import CalculatorNew from "../../components/CalculatorNew";

//NEW CSV STUFF
import Papa from "papaparse";
import extraquestions from '../../assets/NumberAndPlace/ExtraQuestions/numplace_extraquestions.csv';

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;


// Function to handle part-whole display logic for 4-part models (1 whole, 3 parts)
function createPartWholeHtml(nquestion) {
  console.log("trying to create part whole image");
  // Parse the input string from nquestion.value_for_images
  // Example: "PW4,582|4,000|500|80|??"
  let rawValues = [];
  if (nquestion.value_for_images.includes("PW") == false){
    rawValues = [nquestion.value_for_images, nquestion.value_for_images_2, nquestion.value_for_images_3, nquestion.value_for_images_4]
  }else{
    rawValues = nquestion.value_for_images.replace("PW", "").split('|');
  }
  


  let displayWhole = rawValues[0] || "";
  let displayPart1 = rawValues[1] || "";
  let displayPart2 = rawValues[2] || "";
  let displayPart3 = rawValues[3] || ""; // This is the last displayed part

  console.log(rawValues);


  return `
    <div>
      <img src="${GetImage("partwhole4")}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);">
      <b style="font-size:30px; width:145px; position:absolute; top:11%; right:41%;">${displayWhole}</b>
      <b style="font-size:30px; width:145px; position:absolute; top:75%; right:77%;">${displayPart1}</b>
      <b style="font-size:30px; width:145px; position:absolute; top:75%; right:41%;">${displayPart2}</b>
      <b style="font-size:30px; width:145px; position:absolute; top:75%; right:6%;">${displayPart3}</b>
    </div>
  `;
}

function createPartWhole5Html(nquestion) {
  console.log("trying to create part whole image");
  // Parse the input string from nquestion.value_for_images
  // Example: "PW4,582|4,000|500|80|??"
  let rawValues = [];
  if (nquestion.value_for_images.includes("PW") == false){
    rawValues = [nquestion.value_for_images, nquestion.value_for_images_2, nquestion.value_for_images_3, nquestion.value_for_images_4]
  }else{
    rawValues = nquestion.value_for_images.replace("PW", "").split('|');
  }
  


  let displayWhole = rawValues[0] || "";
  let displayPart1 = rawValues[1] || "";
  let displayPart2 = rawValues[2] || "";
  let displayPart3 = rawValues[3] || ""; // This is the last displayed part
  let displayPart4 = rawValues[4] || ""; // This is the last displayed part

  console.log(rawValues);


  return `
    <div>
      <img src="${GetImage("partwhole_5")}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);">
      <b style="font-size:30px; width:145px; position:absolute; top:5%; right:35%;">${displayWhole}</b>
      <b style="font-size:30px; width:145px; position:absolute; top:27%; right:73%;">${displayPart1}</b>
      <b style="font-size:30px; width:145px; position:absolute; top:39%; right:51%;">${displayPart2}</b>
      <b style="font-size:30px; width:145px; position:absolute; top:39%; right:20%;">${displayPart3}</b>
      <b style="font-size:30px; width:145px; position:absolute; top:27%; right:-3%;">${displayPart4}</b>
    </div>
  `;
}


//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function ShuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

//Checks if string is contained in the answer list
function uniqueItem(value, list) {
  for (var i = 0; i < list.length; i++)
    if (value == list[i].value)
      return false;
  return true;
}

//Runs basic formula up to 6 times while not unique
//Makes a resonable random number if this fails
function uniqueFormula(input, insert, list) {
  var ans = parseFormula(input, insert);

  if (uniqueItem(ans, list))
    return ans;

  for (var i = 0; i < 5; i++) {
    ans = parseFormula(input, insert);
    if (uniqueItem(ans, list))
      return ans;
  }


  var max = parseFloat(list[0].value);
  if (max < 10)
    max = 10;
  for (var i = 0; i < 5; i++) {
    ans = parseFormula("Rand|" + parseFloat(max) / 2 + "|" + max + "|1", input, insert);
    if (uniqueItem(ans, list))
      return ans;
  }
  console.log("COULDNT GENERATE UNIQUE NUMBER");

  if (input.includes("Round")) {

  }

  return ans;
}

//Parses the formula from example question
function parseFormula(input, insert) {
  var newInput = input.replace("$", insert[0]).replace("^", insert[1]);
  if (input.includes("|")) {
    let parts = newInput.split('|');
    if (parts[0] === "Add")
      return parseInt(parts[1]) + parseInt(parts[2]);

    else if (parts[0] === "Sub")
      return parseInt(parts[1]) - parseInt(parts[2]);

    else if (parts[0] === "Seque4")
      return parseInt(parts[1]) + "; " + (parseInt(parts[1]) + parseInt(parts[2])) + "; " + (parseInt(parts[1]) + parseInt(parts[2] * 2)) + "; " + (parseInt(parts[1]) + parseInt(parts[2] * 3));

    else if (parts[0] === "Rand")
      return Math.round(parseInt(parts[1]) + Math.random() * (parseInt(parts[2]) - parseInt(parts[1]))) * parseInt(parts[3]);

    else if (parts[0] === "Rand2") {
      var answer = Math.round(parseInt(parts[1]) + Math.random() * (parseInt(parts[2]) - parseInt(parts[1])) / 2) * parseInt(parts[3]);
      var answer2 = Math.round(answer + Math.random() * (parseInt(parts[2]) - parseInt(parts[1])) / 2) * parseInt(parts[3]);
      console.log(answer2);
      return (answer + "|" + answer2);
    }
    else if (parts[0] === "Char")
      return parts[1].toString()[parts[1].length - parseInt(parts[2])];

    else if (parts[0] === "Round") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = Math.round(round) * parseInt(parts[2]);
      return ans;
    }
    else if (parts[0] === "RoundUp") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = 0;
      if (Math.ceil(round) * parseInt(parts[2]) == Math.round(round) * parseInt(parts[2])) {
        ans = Math.ceil(round) * parseInt(parts[2]) + parseInt(parts[2]);
      } else {
        ans = Math.ceil(round) * parseInt(parts[2]);
      }
      return ans;
    }


    else if (parts[0] === "RoundDown") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = 0;
      if (Math.floor(round) * parseInt(parts[2]) == Math.round(round) * parseInt(parts[2])) {
        ans = Math.floor(round) * parseInt(parts[2]) - parseInt(parts[2]);
      } else {
        ans = Math.floor(round) * parseInt(parts[2]);
      }
      return ans;
    }
  }
  return newInput;
}

function numberWithCommas(x) {
  if (x == "?"){
    return x;
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


function GetImage(image) {
  let imgStr = image.replace(/\s/g, ''); 
  return '/qimages/' + imgStr + ".png";
}

//Generates a question from a default question
function Geq(q) {
  //Lookup table for the missing column
  let qKeys = ["Num1Q1", "Num1Q2", "Num3Q1", "Num4Q1", "Num5Q1", "Num6Q1", "Num7Q1", "Num7Q111", "Num9Q1", "Num9Q2", "Num9Q3", "Num11Q1", "Num12Q1", "Num13Q1", "Num14Q1", "Num15Q1", "Num15Q38", "Num15Q112", "Num15Q185", "Num16Q1", "Num16Q123", "Num16Q184", "Num17Q1", "Num17Q2", "Num19Q1", "Num20Q1", "Num21Q1", "Num22Q1", "Num23Q1", "Num24Q1", "Num24Q111", "Num25Q1", "Num25Q111", "Num25Q184", "Num25Q292", "Num26Q1", "Num26Q13", "Num26Q19", "Num26Q24", "Num26Q34", "Num26Q44", "Num26Q53", "Num26Q63", "Num26Q73", "Num26Q83", "Num27Q1", "Num27Q2", "Num28Q1", "Num28Q147", "Num28Q256", "Num29Q1", "Num29Q2", "Num29Q147", "Num29Q148", "Num29Q149", "Num29Q150", "Num29Q151", "Num29Q152", "Num29Q153", "Num29Q154", "Num29Q155", "Num29Q156", "Num29Q239", "Num29Q240", "Num29Q241", "Num29Q242", "Num29Q243", "Num29Q244", "Num29Q245", "Num29Q246", "Num29Q247", "Num29Q248", "Num30Q1", "Num30Q111", "Num30Q184", "Num30Q292", "Num30Q437", "Num30Q546", "Num31Q1", "Num31Q110", "Num32Q1", "Num32Q147", "Num32Q256", "Num32Q363", "Num32Q508", "Num33Q1", "Num33Q2", "Num34Q1", "Num34Q111", "Num34Q184", "Num34Q292", "Num34Q437", "Num34Q546", "Num34Q692", "Num35Q1", "Num35Q147", "Num35Q256", "Num35Q363", "Num35Q508"];
  let generator = ["Rand|11|188|1", "Rand|11|188|1", "Rand|0|30|1", "Rand|0|90|1", "Rand|0|100|1", "Rand|1|15|10", "Rand|10|99|1", "Rand|10|99|1", "Rand|2|20|1", "Rand2|1|100|1", "Rand2|1|100|1", "Rand|0|20|4", "Rand|0|20|8", "Rand|0|12|50", "Rand|0|12|100", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|100|990|1", "Rand|100|990|1", "Rand|100|990|1", "Rand2|100|990|1", "Rand2|100|990|1", "Rand|25|970|1", "Rand|25|970|1", "Rand|25|970|1", "Rand|25|870|1", "Rand|200|9870|1", "Rand|2000|98870|1", "Rand|2000|98870|1", "Rand|100|970|1", "Rand|100|970|1", "Rand|100|970|1", "Rand|10000|97000|1", "Rand|-15|-1|1", "Rand|-20|-2|1", "Rand|-30|-3|1", "Rand|-40|-4|1", "Rand|-50|-5|1", "Rand|-60|-6|1", "Rand|-70|-7|1", "Rand|-80|-8|1", "Rand|-90|-9|1", "Rand|-100|-10|1", "Rand2|1000|9900|1", "Rand2|1000|9900|1", "Rand|1000|9900|1", "Rand|1000|9900|1", "Rand|1000|9900|1", "Rand2|100000|990000|1", "Rand2|100000|990000|1", "Rand|-15|-1|1", "Rand|-20|-2|1", "Rand|-30|-3|1", "Rand|-40|-4|1", "Rand|-50|-5|1", "Rand|-60|-6|1", "Rand|-70|-7|1", "Rand|-80|-8|1", "Rand|-90|-9|1", "Rand|-100|-10|1", "Rand|-15|15|1", "Rand|-20|20|1", "Rand|-30|30|1", "Rand|-40|40|1", "Rand|-50|50|1", "Rand|-60|60|1", "Rand|-70|70|1", "Rand|-80|80|1", "Rand|-90|90|1", "Rand|-100|100|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|10000|97000|1", "Rand|10000|97000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand2|1000000|9900000|1", "Rand2|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1"];
  console.log(q);


  if (q.task_code != undefined) {
    var imageString = "";
    var qhtml = ""
    var questionText = q.questionline1;
    var questionText2 = "";
    var questionType = "MC";
    var wrong = [];
    var correctAnswer = q.correct_answer;
    var qanswers = [];
    var version = "new";

    if (q.topic_key == "num1Sp1S01") {
      //imageString = GetImage("numplace/" + q.correct_answer + "NT" + q.value_for_images);
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.correct_answer + "NT" + q.value_for_images) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "NP";
    }

    else if (q.topic_key == "num1Sp1S03") {
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.correct_answer + "TF") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "NP";

    }
    else if (q.topic_key == "num1Sp1S04") {//PART WHOLE
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:5% ; right:47%'>" + q.value_for_images + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:34% ; right:80%'>" + q.value_for_images_2 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:34% ; right:19%'>" + q.value_for_images_3 + "</b>"
      qhtml += "</div>"
      questionType = "NP";
    }

    else if (q.topic_key == "num1Sp1S05") {
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.correct_answer + "TF") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "NP";
    }

    else if (q.topic_key == "num1Sp1S07") {
      questionType = "NP";
    }
    else if (q.topic_key == "num1Sp1S09") {//numberline10-20
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.correct_answer + "NL" + "10-20") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "NP";
    }
    else if (q.topic_key == "num1Sp1S10") {//numberline estimate
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.correct_answer + "NL" + "10-20-no tabs") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "MC";
    }

    else if (q.topic_key == "num1Sp1S11") {
      questionText = "What symbol is missing: " + q.questionline2;
    }

    else if (q.topic_key == "num1Sp3S01") {//number track
      questionType = "NP";
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:-390px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-100px'>" + q.value_for_images + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-225px'>" + q.value_for_images_2 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-350px'>" + q.value_for_images_3 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-475px'>" + q.value_for_images_4 + "</b>"
      qhtml += "</div>"



    } else if (q.topic_key == "num1Sp3S03") {
      questionType = "NP";
    }
    else if (q.topic_key == "num1Sp3S04" || q.topic_key == "num1Sp3S08") {//ten frame
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.value_for_images) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "NP";
    }

    /*
    else if (q.topic_key == "num1Sp3S05") {//part whole
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:5% ; right:47%'>" + q.value_for_images_3 + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:38% ; right:83%'>" + q.value_for_images_2 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:38% ; right:16%'>" + q.value_for_images + "</b>"
      qhtml += "</div>"
      questionType = "NP";
    }*/

    else if (q.topic_key == "num1Sp3S06") {//number line 1
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.value_for_images) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "NP";
    }
    /*
    else if (q.topic_key == "num1Sp3S07") {//number line estimate MC
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.value_for_images) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "MC";
    }*/
    /*
    else if (q.topic_key == "num2A1S01") {//TEN FRAME 100
      questionType = "NP";
      qhtml = '<img src="' + GetImage("tenframetable") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPos = 70.5;
      var column = 1;
      var topPosTop = -12;
      var topPosBottom = 14;
      var rightModifier = 20;

      var num1 = 10;
      var num2 = q.value_for_images - 10;

      qhtml += "<div>";
      for (let x = 0; x < num1; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2) {
          topPos = topPosBottom;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.4,0.4);  zIndex:-1'" + '></img>'

        if (column == 1) {
          rightPos -= rightModifier;
        }
      }
      qhtml += "</div>";
      qhtml += '<img src="' + GetImage("tenframetable") + '"' + "style='position:absolute ; top: 55%; right:0% ; z-index:1'" + '></img>';
      topPosTop = 43;
      topPosBottom = 67;
      rightPos = 70.5;

      for (let x = 0; x < num2; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2) {
          topPos = topPosBottom;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.4,0.4);  z-index:1'" + '></img>'

        if (column == 1) {
          rightPos -= rightModifier;
        }
      }
    }
    else if (q.topic_key == "num2A1S02") {//TEN FRAME 100
      questionType = "NP";
      qhtml = '';
      //then loop through tens
      var topPosTop = -12;
      let topModifier = 25;

      var num1 = q.value_for_images / 10;
      let toppos = topPosTop;

      var imagestring = "tenframetable_full";
      if (num1 > 5) {
        imagestring = "tenframetable_full_20";
        num1 = num1 - 5;
      }

      qhtml += "<div>";
      for (let x = 0; x < num1; x++) {
        qhtml += '<img src="' + GetImage(imagestring) + '"' + "style='position:absolute ; top: " + toppos + "%; transform: scale(0.4,0.4);  zIndex:-1'" + '></img>';
        toppos += topModifier;
      }
    }

    else if (q.topic_key == "num2A1S03") {
      questionType = "NP";
      //setup the object
      var digits = (q.correct_answer).toString().split('');

      if (digits.count > 2) {
        qhtml = "<div>";
        qhtml += '<img src="' + GetImage("100cube" + digits[0]) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
        qhtml += '<img src="' + GetImage("10cube" + digits[1]) + '"' + "style='position:relative ; right:-5% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
        qhtml += '<img src="' + GetImage("1cube" + digits[2]) + '"' + "style='position:relative ; right:-10% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
        qhtml += "</div>"
      } else {
        qhtml = "<div>";
        qhtml += '<img src="' + GetImage("10cube" + digits[0]) + '"' + "style='position:relative ; right:-5% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
        qhtml += '<img src="' + GetImage("1cube" + digits[1]) + '"' + "style='position:relative ; right:-10% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
        qhtml += "</div>"
      }
    }

    else if (q.topic_key == "num2A1S04") {
      questionType = "NP";
      qhtml = '<img src="' + GetImage("placetabletensones") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(0.6,0.6)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:30% ; right:66%'>" + q.value_for_images[0] + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:30% ; right:37%'>" + q.value_for_images[1] + "</b>";
    }

    else if (q.topic_key == "num2A1S05") {
      questionType = "NP";
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:6% ; right:47%'>" + q.value_for_images + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:37% ; right:80%'>" + q.value_for_images_2 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:37% ; right:19%'>" + q.value_for_images_3 + "</b>"
      qhtml += "</div>"
    }
    else if (q.topic_key == "num2A1S06") {
      questionType = "NP";
    }
    else if (q.topic_key == "num2A1S07") {
      questionType = "NP";
    }
    else if (q.topic_key == "num2A1S08") {
      questionType = "NP";
    }

    else if (q.topic_key == "num2A1S09") {//number line 1
      qhtml = "<div style='width: 800px; height: 200px; position: relative;'>";
      qhtml += '<img src="' + GetImage("numberlineempty") + '"' + "style='position:relative ; top: -15%; right:0% ; zIndex:-1'" + '></img>';
      qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:-5%; right:95%; ;  zIndex:-1'" + '>' + q.value_for_images_2 + '</div>'
      qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:-5%; right:0%; ;  zIndex:-1'" + '>' + q.value_for_images_3 + '</div>'

      var rightPos = 86.6;
      var column = 1;
      var topPos = 0;
      var rightModifier = 9.45;

      for (let x = 1; x < 10; x++) {
        if (x * 10 != q.value_for_images) {
          qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>' + x * 10 + '</div>'
        }
        rightPos -= rightModifier;
      }
      rightPos = 86.6;
      topPos = 0;
      //then draw the red arrows
      for (let x = 1; x < 10; x++) {
        if (x * 10 == q.value_for_images) {
          qhtml += '<div ' + "style='color: red; position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>' + '↓' + '</div>'
        }
        rightPos -= rightModifier;
      }

      qhtml += "</div>"

      questionType = "NP";
    }
    else if (q.topic_key == "num2AS010") {//number line 2
      qhtml = "<div style='width: 800px; height: 200px; position: relative;'>";
      qhtml += '<img src="' + GetImage("numberlineempty") + '"' + "style='position:relative ; top: -15%; right:0% ; zIndex:-1'" + '></img>';
      qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:-5%; right:95%; ;  zIndex:-1'" + '>' + q.value_for_images_2 + '</div>'
      qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:-5%; right:0%; ;  zIndex:-1'" + '>' + q.value_for_images_3 + '</div>'

      var rightPos = 86.6;
      var column = 1;
      var topPos = 0;
      var rightModifier = 9.45;

      var startNum = parseInt(q.value_for_images_2);
      var endNum = parseInt(q.value_for_images_3);
      console.log("Start: " + startNum + "End: " + endNum);

      for (let x = startNum + 1; x < endNum - 1; x++) {
        if (x != q.value_for_images) {
          qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>' + x + '</div>'
        }
        rightPos -= rightModifier;
      }
      rightPos = 86.6;
      topPos = 0;
      //then draw the red arrows
      for (let x = startNum + 1; x < endNum; x++) {
        console.log("Comparing: " + x + "|" + q.correct_answer)
        if (x == q.correct_answer) {
          qhtml += '<div ' + "style='color: red; position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>' + '↓' + '</div>'
        }
        rightPos -= rightModifier;
      }

      qhtml += "</div>"

      questionType = "NP";
    }
    else if (q.topic_key == "num2AS011") {//number line 2
      qhtml = "<div style='width: 800px; height: 200px; position: relative;'>";
      qhtml += '<img src="' + GetImage("numberlineempty") + '"' + "style='position:relative ; top: -15%; right:0% ; zIndex:-1'" + '></img>';
      qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:-5%; right:95%; ;  zIndex:-1'" + '>' + q.value_for_images_2 + '</div>'
      qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:-5%; right:0%; ;  zIndex:-1'" + '>' + q.value_for_images_3 + '</div>'

      var rightPos = 86.6;
      var column = 1;
      var topPos = 0;
      var rightModifier = 9.45;

      var startNum = q.value_for_images_2;
      var endNum = q.value_for_images_3;

      rightPos = 86.6;
      topPos = 0;
      //then draw the red arrows
      for (let x = startNum + 1; x < endNum - 1; x++) {
        if (x == q.value_for_images) {
          qhtml += '<div ' + "style='color: red; position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>' + '↓' + '</div>'
        }
        rightPos -= rightModifier;
      }

      qhtml += "</div>"

      questionType = "NP";
    }
    else if (q.topic_key == "num2AS012") {//number line 2
      questionType = "MC";
    }
    else if (q.topic_key == "num2AS015" || q.topic_key == "num2AS016") {
      questionType = "NP";
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:-390px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-100px'>" + q.value_for_images + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-225px'>" + q.value_for_images_2 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-350px'>" + q.value_for_images_3 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-475px'>" + q.value_for_images_4 + "</b>"
      qhtml += "</div>";

    }
      */
     /*
    else if (q.topic_key == "num1Sp3S07") {//number line estimate MC
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.value_for_images) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
      questionType = "MC";
    }*/

    else if (q.topic_key == "num54S02") {//numberline estimate

      questionType = "MC";
      if (q.image_type != "MC") {
        qhtml = "<div>";
        qhtml += '<img src="' + GetImage("numplace/" + q.value_for_images) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
        qhtml += '</div>'
      } else {
        qhtml = "<div>";
        qhtml += "</div>";
      }
    }

    else if (q.topic_key == "num54S03") {//
      questionType = "MC";
    }
    else if (q.topic_key == "num54S04") {//
      questionType = "MC";
    }
    else if (q.topic_key == "num54S05") {//
      questionType = "NP";
    }

    else if (q.topic_key == "num5A1S02") {
      questionType = "NP";

      // Convert q.value_for_images to digits
      let value = q.value_for_images.toString().padStart(4, '0');
      let thousands = parseInt(value[0]);
      let hundreds = parseInt(value[1]);
      let tens = parseInt(value[2]);
      let ones = parseInt(value[3]);

      // Build place value grid with smaller table image
      qhtml = '<img src="' + GetImage("placetablethousandshundredsones") + '" style="position:relative; right:0%; transform:scale(0.7,0.7); zIndex:-1"></img>';

      // Thousands
      var rightPosLeft = 79;
      var rightPosMiddle = 73;
      var rightPosRight = 67;
      var column = 1;
      var topPos = 20;
      var topModifier = 12;

      qhtml += "<div>";
      for (let x = 0; x < thousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("1000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.8,0.8); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Hundreds
      rightPosLeft = 61;
      rightPosMiddle = 55.5;
      rightPosRight = 50;
      column = 1;
      topPos = 20;

      qhtml += "<div>";
      for (let x = 0; x < hundreds; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("100token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.8,0.8); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Tens
      rightPosLeft = 44;
      rightPosMiddle = 38;
      rightPosRight = 32;
      column = 1;
      topPos = 20;

      qhtml += "<div>";
      for (let x = 0; x < tens; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("10token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.8,0.8); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Ones
      rightPosLeft = 26;
      rightPosMiddle = 20.5;
      rightPosRight = 15;
      column = 1;
      topPos = 20;

      qhtml += "<div>";
      for (let x = 0; x < ones; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("1token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.8,0.8); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
    }
    else if (q.topic_key == "num5A1S03") { //PVG up to 99,999
      questionType = "NP";
      // Convert q.value_for_images to digits
      let value = q.value_for_images.toString().padStart(5, '0');
      let tenThousands = parseInt(value[0]);
      let thousands = parseInt(value[1]);
      let hundreds = parseInt(value[2]);
      let tens = parseInt(value[3]);
      let ones = parseInt(value[4]);

      // Start the grid container with an adjustable width, in the document flow
      qhtml = '<div style="width:110%; display:inline-block; overflow:visible; position:relative;">';

      // Add the table image with constrained width
      qhtml += '<img src="' + GetImage("pvg ten thousands") + '" style="position:relative; right:0%; transform:scale(0.7,0.7); max-width:100%; zIndex:-1"></img>';

      // Ten Thousands
      var rightPosLeft = 79;
      var rightPosMiddle = 75;
      var rightPosRight = 70.5;
      var column = 1;
      var topPos = 25;
      var topModifier = 12;

      qhtml += "<div>";
      for (let x = 0; x < tenThousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("10000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Thousands
      rightPosLeft = 66;
      rightPosMiddle = 61;
      rightPosRight = 57;
      column = 1;
      topPos = 25;

      qhtml += "<div>";
      for (let x = 0; x < thousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("1000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Hundreds
      rightPosLeft = 52;
      rightPosMiddle = 47.5;
      rightPosRight = 43;
      column = 1;
      topPos = 25;

      qhtml += "<div>";
      for (let x = 0; x < hundreds; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("100token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Tens
      rightPosLeft = 38;
      rightPosMiddle = 33.5;
      rightPosRight = 29;
      column = 1;
      topPos = 25;

      qhtml += "<div>";
      for (let x = 0; x < tens; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("10token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Ones
      rightPosLeft = 24;
      rightPosMiddle = 20;
      rightPosRight = 16;
      column = 1;
      topPos = 25;

      qhtml += "<div>";
      for (let x = 0; x < ones; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("1token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Close the grid container
      qhtml += "</div>";

      // Close the grid container
      qhtml += "</div>";

    }
    else if (q.topic_key == "num5A1S04") { //PVG up to 999,999
      questionType = "NP";
      // Convert q.value_for_images to digits
let value = q.value_for_images.toString().padStart(6, '0');
let hundredThousands = parseInt(value[0]);
let tenThousands = parseInt(value[1]);
let thousands = parseInt(value[2]);
let hundreds = parseInt(value[3]);
let tens = parseInt(value[4]);
let ones = parseInt(value[5]);

// Start the grid container with an adjustable width, in the document flow
qhtml = '<div style="width:115%; display:inline-block; overflow:visible;">';

// Add the table image with constrained width
qhtml += '<img src="' + GetImage("pvg hundred thousands") + '" style="position:relative; right:0%; transform:scale(0.7,0.7); max-width:100%; zIndex:-1"></img>';

// Hundred Thousands
var rightPosLeft = 76.5;
var rightPosMiddle = 72.5;
var rightPosRight = 68;
var column = 1;
var topPos = 10;
var topModifier = 9;

qhtml += "<div>";
for (let x = 0; x < hundredThousands; x++) {
  let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
  if (column === 3) {
    rightPos = rightPosRight;
    column = 1;
  } else {
    column++;
  }
  qhtml += '<img src="' + GetImage("100000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5,0.5); zIndex:-1"></img>';
  if (column === 1) {
    topPos += topModifier;
  }
}
qhtml += "</div>";

// Ten Thousands
rightPosLeft = 63.5;
rightPosMiddle = 59.5;
rightPosRight = 55;
column = 1;
topPos = 10;

qhtml += "<div>";
for (let x = 0; x < tenThousands; x++) {
  let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
  if (column === 3) {
    rightPos = rightPosRight;
    column = 1;
  } else {
    column++;
  }
  qhtml += '<img src="' + GetImage("10000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5,0.5); zIndex:-1"></img>';
  if (column === 1) {
    topPos += topModifier;
  }
}
qhtml += "</div>";

// Thousands
rightPosLeft = 50.5;
rightPosMiddle = 45.5;
rightPosRight = 41.5;
column = 1;
topPos = 12;

qhtml += "<div>";
for (let x = 0; x < thousands; x++) {
  let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
  if (column === 3) {
    rightPos = rightPosRight;
    column = 1;
  } else {
    column++;
  }
  qhtml += '<img src="' + GetImage("1000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6,0.6); zIndex:-1"></img>';
  if (column === 1) {
    topPos += topModifier;
  }
}
qhtml += "</div>";

// Hundreds
rightPosLeft = 36.5;
rightPosMiddle = 32;
rightPosRight = 27.5;
column = 1;
topPos = 12;

qhtml += "<div>";
for (let x = 0; x < hundreds; x++) {
  let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
  if (column === 3) {
    rightPos = rightPosRight;
    column = 1;
  } else {
    column++;
  }
  qhtml += '<img src="' + GetImage("100token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6,0.6); zIndex:-1"></img>';
  if (column === 1) {
    topPos += topModifier;
  }
}
qhtml += "</div>";

// Tens
rightPosLeft = 22.5;
rightPosMiddle = 18;
rightPosRight = 13.5;
column = 1;
topPos = 12;

qhtml += "<div>";
for (let x = 0; x < tens; x++) {
  let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
  if (column === 3) {
    rightPos = rightPosRight;
    column = 1;
  } else {
    column++;
  }
  qhtml += '<img src="' + GetImage("10token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6,0.6); zIndex:-1"></img>';
  if (column === 1) {
    topPos += topModifier;
  }
}
qhtml += "</div>";

// Ones
rightPosLeft = 8.5;
rightPosMiddle = 4.5;
rightPosRight = 0.5;
column = 1;
topPos = 12;

qhtml += "<div>";
for (let x = 0; x < ones; x++) {
  let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
  if (column === 3) {
    rightPos = rightPosRight;
    column = 1;
  } else {
    column++;
  }
  qhtml += '<img src="' + GetImage("1token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6,0.6); zIndex:-1"></img>';
  if (column === 1) {
    topPos += topModifier;
  }
}
qhtml += "</div>";

// Close the grid container
qhtml += "</div>";

    }
    else if (q.topic_key == "num5A1S05") {
      questionType = "NP";
    }
    else if (q.topic_key == "num5A1S06") {
      questionType = "NP";
    }
    else if (q.topic_key == "num5A1S07") {
      questionType = "NP";
    }
    else if (q.topic_key == "num5A1S08") {
      questionType = "NP";
    }
    else if (q.topic_key == "num5A1S09") {
      questionType = "NP";
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.value_for_images) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
    }
    else if (q.topic_key == "num5A1S10") {
      questionType = "MC";
    }
    else if (q.topic_key == "num5A1S11") {
      questionType = "MC";
    }
    else if (q.topic_key == "num5A1S12") {
      questionType = "NP";
    }
    else if (q.topic_key == "num5A1S13") {
      questionType = "NP";
    }
    else if (q.topic_key == "num5A1S14") {
      questionType = "NP";
    }
        else if (q.topic_key == "num6A1S01") { //PVG up to 999,999 year 6
      questionType = "NP";
            // Convert q.value_for_images to digits
      let value = q.value_for_images.toString().padStart(6, '0');
      let hundredThousands = parseInt(value[0]);
      let tenThousands = parseInt(value[1]);
      let thousands = parseInt(value[2]);
      let hundreds = parseInt(value[3]);
      let tens = parseInt(value[4]);
      let ones = parseInt(value[5]);

      // Start the grid container with an adjustable width, in the document flow
      qhtml = '<div style="width:115%; display:inline-block; overflow:visible;">';

      // Add the table image with constrained width
      qhtml += '<img src="' + GetImage("pvg hundred thousands") + '" style="position:relative; right:0%; transform:scale(0.7,0.7); max-width:100%; zIndex:-1"></img>';

      // Hundred Thousands
      var rightPosLeft = 76.5;
      var rightPosMiddle = 72.5;
      var rightPosRight = 68;
      var column = 1;
      var topPos = 10;
      var topModifier = 9;

      qhtml += "<div>";
      for (let x = 0; x < hundredThousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("100000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5,0.5); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Ten Thousands
      rightPosLeft = 63.5;
      rightPosMiddle = 59.5;
      rightPosRight = 55;
      column = 1;
      topPos = 10;

      qhtml += "<div>";
      for (let x = 0; x < tenThousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("10000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5,0.5); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Thousands
      rightPosLeft = 50.5;
      rightPosMiddle = 45.5;
      rightPosRight = 41.5;
      column = 1;
      topPos = 12;

      qhtml += "<div>";
      for (let x = 0; x < thousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("1000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6,0.6); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Hundreds
      rightPosLeft = 36.5;
      rightPosMiddle = 32;
      rightPosRight = 27.5;
      column = 1;
      topPos = 12;

      qhtml += "<div>";
      for (let x = 0; x < hundreds; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("100token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6,0.6); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Tens
      rightPosLeft = 22.5;
      rightPosMiddle = 18;
      rightPosRight = 13.5;
      column = 1;
      topPos = 12;

      qhtml += "<div>";
      for (let x = 0; x < tens; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("10token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6,0.6); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Ones
      rightPosLeft = 8.5;
      rightPosMiddle = 4.5;
      rightPosRight = 0.5;
      column = 1;
      topPos = 12;

      qhtml += "<div>";
      for (let x = 0; x < ones; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("1token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.6,0.6); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Close the grid container
      qhtml += "</div>";

    }
    else if (q.topic_key == "num6A1S02") { //PVG up to 9,999,999 year 6
      questionType = "NP";
            // Convert q.value_for_images to digits
      let value = q.value_for_images.toString().padStart(7, '0');
      let millions = parseInt(value[0]);
      let hundredThousands = parseInt(value[1]);
      let tenThousands = parseInt(value[2]);
      let thousands = parseInt(value[3]);
      let hundreds = parseInt(value[4]);
      let tens = parseInt(value[5]);
      let ones = parseInt(value[6]);

      // Start the grid container with an adjustable width, in the document flow
      qhtml = '<div style="width:115%; display:inline-block; overflow:visible;">';

      // Add the table image with constrained width
      qhtml += '<img src="' + GetImage("place table millions") + '" style="position:relative; right:0%; transform:scale(0.7,0.7); max-width:102%; zIndex:-1"></img>';


      // Millions
  var rightPosLeft = 76;
  var rightPosMiddle = 72;
  var rightPosRight = 68.5;
  var column = 1;
  var topPos = 10;
  var topModifier = 7;

  qhtml += "<div>";
  for (let x = 0; x < millions; x++) {
    let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
    if (column === 3) {
      rightPos = rightPosRight;
      column = 1;
    } else {
      column++;
    }
    qhtml += '<img src="' + GetImage("1mtoken") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.4); zIndex:-1"></img>';
    if (column === 1) {
      topPos += topModifier;
    }
  }
  qhtml += "</div>";


      // Hundred Thousands
      var rightPosLeft = 64.5;
      var rightPosMiddle = 61;
      var rightPosRight = 57;
      var column = 1;
      var topPos = 10;
      var topModifier = 7;

      qhtml += "<div>";
      for (let x = 0; x < hundredThousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("100000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.4); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Ten Thousands
      rightPosLeft = 53;
      rightPosMiddle = 49;
      rightPosRight = 45;
      column = 1;
      topPos = 10;

      qhtml += "<div>";
      for (let x = 0; x < tenThousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("10000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.4); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Thousands
      rightPosLeft = 42;
      rightPosMiddle = 38;
      rightPosRight = 34;
      column = 1;
      topPos = 12;

      qhtml += "<div>";
      for (let x = 0; x < thousands; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("1000token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Hundreds
      rightPosLeft = 29;
      rightPosMiddle = 26;
      rightPosRight = 23;
      column = 1;
      topPos = 12;

      qhtml += "<div>";
      for (let x = 0; x < hundreds; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("100token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Tens
      rightPosLeft = 18;
      rightPosMiddle = 14.5;
      rightPosRight = 11;
      column = 1;
      topPos = 12;

      qhtml += "<div>";
      for (let x = 0; x < tens; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("10token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Ones
      rightPosLeft = 7;
      rightPosMiddle = 3;
      rightPosRight = -1;
      column = 1;
      topPos = 12;

      qhtml += "<div>";
      for (let x = 0; x < ones; x++) {
        let rightPos = column === 1 ? rightPosLeft : column === 2 ? rightPosMiddle : rightPosRight;
        if (column === 3) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column++;
        }
        qhtml += '<img src="' + GetImage("1token") + '" style="position:absolute; top:' + topPos + '%; right:' + rightPos + '%; transform:scale(0.5); zIndex:-1"></img>';
        if (column === 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      // Close the grid container
      qhtml += "</div>";

    }

    else if (q.topic_key == "num6A1S03") {
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("partwhole4") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ; width:145px; position:absolute ; top:11% ; right:41%'>" + numberWithCommas(q.value_for_images) + "</b>";
      qhtml += "<b style='font-size:30px ; width:145px; position:absolute ; top:75% ; right:77%'>" + numberWithCommas(q.value_for_images_2) + "</b>"
      qhtml += "<b style='font-size:30px ; width:145px; position:absolute ; top:75% ; right:41%'>" + numberWithCommas(q.value_for_images_3) + "</b>"
      qhtml += "<b style='font-size:30px ; width:145px;  position:absolute ; top:75% ; right:6%'>" + numberWithCommas(q.value_for_images_4) + "</b>"
      qhtml += "</div>"
      questionType = "NP";
    }
    else if (q.topic_key == "num6A1S04") {
      questionType = "NP";
    }
    else if (q.topic_key == "num6A1S05") {
      questionType = "NP";
      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/" + q.value_for_images) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += '</div>'
    }

    else if (q.topic_key == "num6A1S06")
    {
        questionType = "MC";
    }
    else if (q.topic_key == "num6A1S07")
    {
        questionType = "NP";
    }
    else if (q.topic_key == "num6A1S08")
    {
        questionType = "MC";
    }
    if (q.topic_key === "num1S4S01") {
          qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:-390px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-100px'>" + q.value_for_images + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-225px'>" + q.value_for_images_2 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-350px'>" + q.value_for_images_3 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-475px'>" + q.value_for_images_4 + "</b>"
      qhtml += "</div>"
    questionType = "NP"; // Number Pad
  } else if (q.topic_key === "num1S4S02") {
    questionType = "NP";
    
  } else if (q.topic_key === "num1S4S03") {
    questionType = "NP";
    
  } else if (q.topic_key === "num1S4S04") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.image_type)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
  } else if (q.topic_key === "num1S4S05") {
    questionType = "NP";
    
  } else if (q.topic_key === "num1S4S06") {
    questionType = "MC";
    
  } else if (q.topic_key === "num1S4S07") {
    questionType = "MC";
    
  } else if (q.topic_key === "num4A1S01") { // rods
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
  } else if (q.topic_key === "num4A1S02") {
        qhtml = createPartWholeHtml(q);
    questionType = "NP";
  } else if (q.topic_key === "num4A1S03") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
  } else if (q.topic_key === "num4A1S04") {
    questionType = "NP";
    
  } else if (q.topic_key === "num4A1S05") {
    const digits = String(parseInt(q.correct_answer)).split('').map(Number);
    let tempHtml = '<img src="' + GetImage("placetablethousandshundredsones") + '" style="position:relative; right:0%; zIndex:-1; transform:scale(0.7,0.7);"></img>';

    const positions = {
      thousands: { right: [89, 84, 79], top: 20, modifier: 12, rightMod: -10 }, // Added rightMod
      hundreds: { right: [64, 59, 54], top: 20, modifier: 12, rightMod: -3 }, // Added rightMod
      tens: { right: [39, 34, 29], top: 20, modifier: 12, rightMod: 5 },     // Added rightMod
      ones: { right: [14, 9, 4], top: 20, modifier: 12, rightMod: 12 }        // Added rightMod
    };

    const tokenImages = {
      thousands: "1000token",
      hundreds: "100token",
      tens: "10token",
      ones: "1token"
    };

    const placeValueOrder = ['thousands', 'hundreds', 'tens', 'ones'];

    for (let x = 0; x < digits.length; x++) {
        let currentPlace = placeValueOrder[x + (4 - digits.length)]; // Adjust index for number of digits
        let count = digits[x];
        let currentPos = positions[currentPlace];
        let col = 0; // Start column index at 0 for array access
        let currentTop = currentPos.top;

        for (let i = 0; i < count; i++) {
            let rightOffset = currentPos.right[col] + currentPos.rightMod; // Access the right position based on column index
            tempHtml += `<img src="${GetImage(tokenImages[currentPlace])}" style="position:absolute; top:${currentTop}%; right:${rightOffset}%; transform:scale(0.8,0.8); zIndex:-1;"></img>`;
            
            col++; // Increment column
            if (col === 3) { // If 3 tokens have been placed, reset column and move to next row
                col = 0;
                currentTop += currentPos.modifier;
            }
        }
    }
    qhtml = `<div>${tempHtml}</div>`;
    questionType = "NP";
  } else if (q.topic_key === "num4A1S06" || q.topic_key === "num4A1S07") {
    qhtml = createPartWhole5Html(q);
    questionType = "NP";
  } else if (q.topic_key === "num4A1S08") {
    questionType = "NP";
    
  } else if (q.topic_key === "num4A1S09") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
  } else if (q.topic_key === "num4A1S10") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "MC";
  } else if (q.topic_key === "num4A1S11") {
    questionType = "MC";
    
  } else if (q.topic_key === "num4A1S12") {
    questionType = "MC";
    
  } else if (q.topic_key === "num4A1S14") {
    questionType = "NP";
    
  } else if (q.topic_key === "num4A1S15") {
    questionType = "NP";
    
  } else if (q.topic_key === "num4A1S16") {
    questionType = "NP";
    
  } else if (q.topic_key === "num4A1S17") {
    questionType = "NP";
    
  } else if (q.topic_key === "num3A1S01") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images_2)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
  } else if (q.topic_key === "num3A1S02") {
          qhtml = "<div>";
      qhtml += '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:5% ; right:47%'>" + q.value_for_images + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:34% ; right:80%'>" + q.value_for_images_2 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:34% ; right:19%'>" + q.value_for_images_3 + "</b>"
      qhtml += "</div>"
    questionType = "NP";
  } else if (q.topic_key === "num3A1S06"){
    qhtml = createPartWholeHtml(q);
    questionType = "NP";
  } else if (q.topic_key === "num3A1S03") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.image_type)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "MC";
  } else if (q.topic_key === "num3A1S04") {
    questionType = "NP";
    
  } else if (q.topic_key === "num3A1S05") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
  } else if (q.topic_key === "num3A1S07") {
    questionType = "NP";
    
  } else if (q.topic_key === "num3A1S08") {
    const digits = String(parseInt(q.correct_answer)).split('').map(Number);
    let tempHtml = '<img src="' + GetImage("placetablehundredstensones") + '" style="position:relative; right:0%; zIndex:-1; transform:scale(0.7,0.7);"></img>';

    const positions = {
      hundreds: { right: [71, 60], top: 22, modifier: 8 },
      tens: { right: [47, 38], top: 22, modifier: 8 },
      ones: { right: [25, 15], top: 22, modifier: 8 }
    };

    const tokenImages = {
      hundreds: "100token",
      tens: "10token",
      ones: "1token"
    };

    const placeValueOrder = ['hundreds', 'tens', 'ones'];

    for (let x = 0; x < digits.length; x++) {
      let currentPlace = placeValueOrder[x + (3 - digits.length)]; // Adjust index for number of digits
        let count = digits[x];
        let currentPos = positions[currentPlace];
        let col = 1;
        let currentTop = currentPos.top;

        for (let i = 0; i < count; i++) {
            let rightOffset = col === 1 ? currentPos.right[0] : currentPos.right[1];
            tempHtml += `<img src="${GetImage(tokenImages[currentPlace])}" style="position:absolute; top:${currentTop}%; right:${rightOffset}%; transform:scale(0.5,0.5); zIndex:-1;"></img>`;
            if (col === 2) {
                col = 1;
                currentTop += currentPos.modifier;
            } else {
                col++;
            }
        }
    }
    qhtml = `<div>${tempHtml}</div>`;
    questionType = "NP";
  } else if (q.topic_key === "num3A1S09") {
    questionType = "NP";
  } else if (q.topic_key === "num3A1S10") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.image_type)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "MC";
  } else if (q.topic_key === "num3A1S11") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.image_type)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "MC";
  } else if (q.topic_key === "num3A1S13") {
    questionType = "MC";
  } else if (q.topic_key === "num3A1S14") {
          qhtml = "<div>";
      qhtml += '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:-390px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-100px'>" + q.value_for_images + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-225px'>" + q.value_for_images_2 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-350px'>" + q.value_for_images_3 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:46% ; right:-475px'>" + q.value_for_images_4 + "</b>"
      qhtml += "</div>"
    questionType = "NP";
  }

  //new questions

else if (q.topic_key === "num1A1S02") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images_2)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
} else if (q.topic_key === "num1A1S03") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images_2)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
} else if (q.topic_key === "num1A1S04") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images_2)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
} else if (q.topic_key === "num1A1S05") {
    questionType = "MC";
} else if (q.topic_key === "num1A1S05b") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images_2)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "MC";
} else if (q.topic_key === "num1A1S06") {
    qhtml = "<div>";
    qhtml += '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:-390px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-100px;'>${q.value_for_images}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-225px;'>${q.value_for_images_2}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-350px;'>${q.value_for_images_3}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-475px;'>${q.value_for_images_4}</b>`;
    qhtml += "</div>";
    questionType = "NP";
} else if (q.topic_key === "num1A1S07") {
    questionType = "NP";
} else if (q.topic_key === "num1A1S08") {
    qhtml = "<div>";
    qhtml += '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:-390px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-100px;'>${q.value_for_images}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-225px;'>${q.value_for_images_2}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-350px;'>${q.value_for_images_3}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-475px;'>${q.value_for_images_4}</b>`;
    qhtml += "</div>";
    questionType = "NP";
} else if (q.topic_key === "num1A1S09") {
    questionType = "NP";
} else if (q.topic_key === "num1A1S011" || q.topic_key === "num1A1S012" || q.topic_key === "num1A1S013" || q.topic_key === "num1A1S014a" || q.topic_key === "num1AS014b") {
    questionType = "MC";
} else if (q.topic_key === "num1AS015") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
} else if (q.topic_key === "num1Sp3S01") {
    qhtml = "<div>";
    qhtml += '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:-390px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-100px;'>${q.value_for_images}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-225px;'>${q.value_for_images_2}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-350px;'>${q.value_for_images_3}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-475px;'>${q.value_for_images_4}</b>`;
    qhtml += "</div>";
    questionType = "NP";
} else if (q.topic_key === "num1Sp3S03") {
    questionType = "NP";
} else if (q.topic_key === "num1Sp3S04") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
} else if (q.topic_key === "num1Sp3S05") {
    qhtml = "<div>";
    qhtml += '<img src="' + GetImage("numplace/wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
    qhtml += `<b style='font-size:30px; position:absolute; top:5%; right:47%;'>${q.value_for_images_4}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:34%; right:80%;'>${q.value_for_images_3}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:34%; right:19%;'>${q.value_for_images_2}</b>`;
    qhtml += "</div>";
    questionType = "NP";

} else if (q.topic_key === "num1Sp3S07") {
    const startNumber = parseFloat(q.value_for_images_2);
    const endNumber = parseFloat(q.value_for_images_3);
    const markedNumber = parseFloat(q.correct_answer);
    const percentagePosition = ((markedNumber - startNumber) / (endNumber - startNumber)) * 100;

    qhtml = `
        <div style="width: 800px; height: 200px; position: relative; margin: 0 auto;">
            <img src="${GetImage("numplace/numberlineestimate")}" style="position:absolute; top:0; left:0; zIndex:-1; width: 100%;">
            <div style="position:absolute; font-weight: bold; font-size: 3em; top: 15%; left: 3%; transform: translateX(-50%); zIndex:1;">${startNumber}</div>
            <div style="position:absolute; font-weight: bold; font-size: 3em; top: 15%; right: 3%; transform: translateX(50%); zIndex:1;">${endNumber}</div>
            <div style="color: red; position:absolute; font-weight: bold; font-size: 3em; top: 15%; left: ${percentagePosition}%; transform: translateX(-50%); zIndex:1;">↓</div>
        </div>
    `;
    questionType = "MC";
}else if (q.topic_key === "num1Sp3S06") {
    questionType = "NP";
    const startNumber = parseInt(q.value_for_images_2);
    const endNumber = parseInt(q.value_for_images_3);
    const markedNumber = parseInt(q.correct_answer);
    const totalNumbers = endNumber - startNumber + 1;
    let numberHtml = "";

    for (let i = 0; i < totalNumbers; i++) {
        const currentNumber = startNumber + i;
        const percentagePosition = (i / (totalNumbers - 1)) * 93 + 3;
        const numberElement = `
            <div style="position:absolute; font-weight: bold; font-size: 3em; top: 15%; left: ${percentagePosition}%; transform: translateX(-50%); zIndex:1;">
                ${currentNumber !== markedNumber ? currentNumber : ''}
            </div>
        `;
        const markerElement = `
            <div style="color: red; position:absolute; font-weight: bold; font-size: 3em; top: 9%; left: ${percentagePosition}%; transform: translateX(-50%); zIndex:1;">
                ${currentNumber === markedNumber ? '↓' : ''}
            </div>
        `;
        numberHtml += numberElement + markerElement;
    }

    qhtml = `
        <div style="width: 800px; height: 200px; position: relative; margin: 0 auto; display: flex; align-items: center; justify-content: center;">
            <img src="${GetImage("numplace/numberlineempty")}" style="position:absolute; top:0; left:0; zIndex:-1; width: 100%;">
            ${numberHtml}
        </div>
    `;
} else if (q.topic_key === "num1Sp3S08") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.value_for_images)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
} else if (q.topic_key === "num2A1S01" || q.topic_key === "num2A1S02" || q.topic_key === "num2A1S03") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.image_type)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";
} else if (q.topic_key == "num2A1S04") {
      questionType = "NP";
      qhtml = '<img src="' + GetImage("placetabletensones") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(0.6,0.6)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:30% ; right:66%'>" + q.value_for_images[0] + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:30% ; right:37%'>" + q.value_for_images[1] + "</b>";
    }
     else if (q.topic_key === "num2A1S05") {
    qhtml = "<div>";
    qhtml += '<img src="' + GetImage("numplace/wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
    qhtml += `<b style='font-size:30px; position:absolute; top:5%; right:47%;'>${q.value_for_images}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:34%; right:80%;'>${q.value_for_images_2}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:34%; right:19%;'>${q.value_for_images_3}</b>`;
    qhtml += "</div>";
    questionType = "NP";
} else if (q.topic_key === "num2A1S06" || q.topic_key === "num2A1S07" || q.topic_key === "num2A1S08") {
    questionType = "NP";
} else if (q.topic_key === "num2A1S09" || q.topic_key === "num2AS010") {
    qhtml = `<div><img src="${GetImage("numplace/" + q.image_type)}" style="position:relative; right:4%; zIndex:-1; transform: scale(1.0,1.0);"></div>`;
    questionType = "NP";

    //estimate numberlines, this needs a new image and the red arrow needs moving a little
}else if (q.topic_key === "num2AS011") {
    const startNumber = parseFloat(q.value_for_images_2);
    const endNumber = parseFloat(q.value_for_images_3);
    const markedNumber = parseFloat(q.value_for_images);

    // Calculate the percentage position of the arrow
    const percentagePosition = ((markedNumber - startNumber) / (endNumber - startNumber)) * 100;

    qhtml = `
        <div style="width: 800px; height: 200px; position: relative; margin: 0 auto;">
            <img src="${GetImage("numplace/numberlineestimate")}" style="position:relative; top:-15%; right:0%; zIndex:-1; width: 100%;">
            <div style="position:absolute; font-weight: bold; font-size: 3em; top:-5%; left: 0%; zIndex:-1;">${startNumber}</div>
            <div style="position:absolute; font-weight: bold; font-size: 3em; top:-5%; right: 0%; zIndex:-1;">${endNumber}</div>
            <div style="color: red; position:absolute; font-weight: bold; font-size: 3em; top: 15%; left: ${percentagePosition}%; transform: translateX(-50%); zIndex:-1;">↓</div>
        </div>
    `;
    questionType = "MC";
    
}else if (q.topic_key === "num2AS012") {
    questionText = "What symbol is missing: " + q.questionline2;
    questionType = "MC";
} else if (q.topic_key === "num2AS013" || q.topic_key === "num2AS014") {
    questionType = "MC";
} else if (q.topic_key === "num2AS015" || q.topic_key === "num2AS016") {
    qhtml = "<div>";
    qhtml += '<img src="' + GetImage("numplace/NTblank") + '"' + "style='position:absolute ; right:-390px ; top: 44%; zIndex:-1;transform: scale(2.0,2.0)'" + '></img>';
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-100px;'>${q.value_for_images}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-225px;'>${q.value_for_images_2}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-350px;'>${q.value_for_images_3}</b>`;
    qhtml += `<b style='font-size:30px; position:absolute; top:46%; right:-475px;'>${q.value_for_images_4}</b>`;
    qhtml += "</div>";
    questionType = "NP";
}


    



    if (q.incorrect_answer_1 != "" && q.incorrect_answer_1 != undefined) {
      //multichoice
      questionType = "MC";
      //add answers
      qanswers.push({ correct: true, value: q.correct_answer });
      qanswers.push({ correct: false, value: q.incorrect_answer_1 });
      if (q.incorrect_answer_2 != "" && q.incorrect_answer_2 != undefined) {
        qanswers.push({ correct: false, value: q.incorrect_answer_2 });
      }
      if (q.incorrect_answer_3 != "" && q.incorrect_answer_3 != undefined) {
        qanswers.push({ correct: false, value: q.incorrect_answer_3 });
      }
      ShuffleArray(qanswers);
    }

    //Creates object to return
    let questionObj = {
      question: questionText,
      answers: qanswers,
      correct: correctAnswer,
      image: imageString,
      questionHTML: qhtml,
      topic_id: null,
      topic_key: q.topic_key,
      type: questionType,
      version: version
    };


    return questionObj;


  }


  else {

    var imageString = "";
    var qhtml = ""


    if (q.topic_key == "num48") {//3 digit number from a sum
      let hundreds = GenerateRandom(1, 9);
      let tens = GenerateRandom(1, 9);
      let ones = GenerateRandom(1, 9);
      var correctAnswer = hundreds * 100 + tens * 10 + ones;
      questionText = hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(100, 999, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });
    }
    else if (q.topic_key == "newnum1") {//count backwards below 10
      let num1 = GenerateRandom(6, 10);
      let num2 = GenerateRandom(1, 5);
      var correctAnswer = num1 - num2;

      questionText = "Start at " + num1 + " and count back " + num2;

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1, 9, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });
    }
    else if (q.topic_key == "newnum2") {//biggest number
      let num1 = GenerateRandom(5, 20);

      var correctAnswer = num1;

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1, num1 - 1, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      shuffleArray(usedAnswers);

      questionText = "Which is the biggest number? " + usedAnswers[0] + ", " + usedAnswers[1] + ", " + usedAnswers[2] + ", " + usedAnswers[3];
    }
    else if (q.topic_key == "newnum3") {//smallest number
      let num1 = GenerateRandom(5, 20);

      var correctAnswer = num1;

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(num1, 20, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      shuffleArray(usedAnswers);

      questionText = "Which is the smallest number? " + usedAnswers[0] + ", " + usedAnswers[1] + ", " + usedAnswers[2] + ", " + usedAnswers[3];
    }
    else if (q.topic_key == "newnum4") {//number line
      let num1 = GenerateRandom(1, 9);

      var correctAnswer = num1;
      questionText = "Which number is missing from the number line?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1, 9, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      shuffleArray(usedAnswers);

      qhtml = '<img src="' + GetImage("numberlineblank") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';

      var rightPos = 86.6;
      var column = 1;
      var topPos = 20;
      var rightModifier = 9.45;

      for (let x = 1; x < 10; x++) {
        //swaps columns

        if (x == num1) {
          qhtml += '<div ' + "style='position:absolute ; color: red; font-weight: bold; font-size: 3.5em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>?</div>'
        } else {
          qhtml += '<div ' + "style='position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>' + x + '</div>'
        }
        rightPos -= rightModifier;
      }


    }

    else if (q.topic_key == "newnum6") { //ten frame 1-10
      let num1 = GenerateRandom(1, 10);

      var correctAnswer = num1;
      questionText = "What number is represented in the ten frame?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1, 10, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      qhtml = '<img src="' + GetImage("tenframetable") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPos = 70.5;
      var column = 1;
      var topPosTop = -25;
      var topPosBottom = 25;
      var rightModifier = 20;

      qhtml += "<div>";
      for (let x = 0; x < num1; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2) {
          topPos = topPosBottom;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.4,0.4);  zIndex:-1'" + '></img>'

        if (column == 1) {
          rightPos -= rightModifier;
        }
      }
      qhtml += "</div>";
    }
    else if (q.topic_key == "newnum5") { //how many rockets
      let num1 = GenerateRandom(1, 10);

      var correctAnswer = num1;
      questionText = "How many rockets?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1, 10, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      //then loop through tens
      var rightPos = 70.5;
      var column = 1;
      var topPosTop = -25;
      var topPosBottom = 25;
      var rightModifier = 20;

      qhtml = '<img src="' + GetImage("blank") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';

      qhtml += "<div>";
      for (let x = 0; x < num1; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2) {
          topPos = topPosBottom;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("rocket") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.4,0.4);  zIndex:-1'" + '></img>'

        if (column == 1) {
          rightPos -= rightModifier;
        }
      }
      qhtml += "</div>";
    }

    else if (q.topic_key == "num58") {//10-99 missing part whole model
      let num1 = GenerateRandom(10, 49);
      let num2 = GenerateRandom(10, 49);
      let num3 = num1 + num2;
      let correctAnswer = num2;

      questionText = "What number is missing from the part-whole model?";

      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:10% ; right:47%'>" + num3 + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + num1 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + "?" + "</b>"
      qhtml += "</div>"

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(10, 49, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });
    }
    else if (q.topic_key == "num57") {//10-99 missing part whole model
      let num1 = GenerateRandom(10, 49);
      let num2 = GenerateRandom(10, 49);
      var correctAnswer = num1 + num2;
      questionText = "What number is missing from the part-whole model?";

      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + "?" + "</b>";
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + num1 + "</b>"
      qhtml += "<b style='font-size:30px ;  position:absolute ; top:73% ; right:16%'>" + num2 + "</b>"
      qhtml += "</div>"

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(10, 99, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });
    }
    else if (q.topic_key == "num53") {//100-999 base ten blocks
      let hundreds = GenerateRandom(1, 9);
      let tens = GenerateRandom(1, 9);
      let ones = GenerateRandom(1, 9);
      var correctAnswer = hundreds * 100 + tens * 10 + ones;
      questionText = "What number is represented by the base ten blocks?";

      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("100cube" + hundreds) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
      qhtml += '<img src="' + GetImage("10cube" + tens) + '"' + "style='position:relative ; right:-5%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
      qhtml += '<img src="' + GetImage("1cube" + ones) + '"' + "style='position:relative ; right:-10%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
      qhtml += "</div>"

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(100, 999, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });
    }
    else if (q.topic_key == "num49") {//1000-9999 base ten blocks
      let thousands = GenerateRandom(1, 6);
      let hundreds = GenerateRandom(1, 9);
      let tens = GenerateRandom(1, 9);
      let ones = GenerateRandom(1, 9);
      var correctAnswer = thousands * 1000 + hundreds * 100 + tens * 10 + ones;
      questionText = "What number is represented by the base ten blocks?";

      qhtml = "<div>";
      qhtml += '<img src="' + GetImage("1000cube" + thousands) + '"' + "style='position:relative ; right:14% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
      qhtml += '<img src="' + GetImage("100cube" + hundreds) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
      qhtml += '<img src="' + GetImage("10cube" + tens) + '"' + "style='position:relative ; right:-5%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
      qhtml += '<img src="' + GetImage("1cube" + ones) + '"' + "style='position:relative ; right:-10%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
      qhtml += "</div>"

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1000, 6999, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });
    }
    else if (q.topic_key == "num8") {//numberline
      let line = GenerateRandom(1, 19);
      var correctAnswer = line;
      questionText = "What number is shown on the number line?";
      imageString = "numberline" + line;

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1, 19, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

    }
    else if (q.topic_key == "num61") { //ten frame
      let num1 = GenerateRandom(1, 9);
      let num2 = GenerateRandom(1, 9);

      var correctAnswer = num1 + num2;
      questionText = "What number is represented in the ten frame?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(2, 20, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      qhtml = '<img src="' + GetImage("tenframetablequestion") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPos = 84.5;
      var column = 1;
      var topPosTop = 4;
      var topPosBottom = 28;
      var rightModifier = 7;

      qhtml += "<div>";
      for (let x = 0; x < num1; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2) {
          topPos = topPosBottom;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.3,0.3);  zIndex:-1'" + '></img>'

        if (column == 1) {
          rightPos -= rightModifier;
        }
      }
      qhtml += "</div>";
      //loop through ones
      var rightPos = 37.8;
      var column = 1;
      var topPosTop = 4;
      var topPosBottom = 28;
      var rightModifier = 7;

      qhtml += "<div>";
      for (let x = 0; x < num2; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2) {
          topPos = topPosBottom;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.3,0.3);  zIndex:-1'" + '></img>'

        if (column == 1) {
          rightPos -= rightModifier;
        }
      }
      qhtml += "</div>";
    }
    else if (q.topic_key == "num60") { //place value grid 1-99
      let tens = GenerateRandom(1, 8);
      let ones = GenerateRandom(1, 8);

      var correctAnswer = tens * 10 + ones;
      questionText = "What number is shown on in the place value grid?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(10, 99, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      qhtml = '<img src="' + GetImage("placetabletensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPosLeft = 75;
      var rightPosRight = 55;
      var column = 1;
      var topPos = 10;
      var topModifier = 15;

      qhtml += "<div>";
      for (let x = 0; x < tens; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
      //loop through ones
      var rightPosLeft = 25;
      var rightPosRight = 5;
      var column = 1;
      var topPos = 10;
      var topModifier = 15;

      qhtml += "<div>";
      for (let x = 0; x < ones; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
    }
    else if (q.topic_key == "num55") { //place value grid 1-99 ODD OR EVEN
      let tens = GenerateRandom(1, 9);
      let ones = GenerateRandom(1, 9);

      var num1 = tens * 10 + ones;

      var questionText = "Is the number " + num1 + " odd or even?";

      var questionAnswers = [];
      if (num1 % 2 == 0) {//even
        var correctAnswer = "Even";
        questionAnswers.push({ correct: true, value: "Even" });
        questionAnswers.push({ correct: false, value: "Odd" });
      } else {//odd
        var correctAnswer = "Odd";
        questionAnswers.push({ correct: true, value: "Odd" });
        questionAnswers.push({ correct: false, value: "Even" });
      }

      qhtml = '<img src="' + GetImage("placetabletensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPosLeft = 75;
      var rightPosRight = 55;
      var column = 1;
      var topPos = 10;
      var topModifier = 15;

      qhtml += "<div>";
      for (let x = 0; x < tens; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
      //loop through ones
      var rightPosLeft = 25;
      var rightPosRight = 5;
      var column = 1;
      var topPos = 10;
      var topModifier = 15;

      qhtml += "<div>";
      for (let x = 0; x < ones; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
    }

    else if (q.topic_key == "num40") { //place value grid 100-999
      let hundreds = GenerateRandom(1, 9);
      let tens = GenerateRandom(1, 9);
      let ones = GenerateRandom(1, 9);

      var correctAnswer = hundreds * 100 + tens * 10 + ones;
      questionText = "What number is shown on in the place value grid?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(100, 999, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      qhtml = '<img src="' + GetImage("placetablehundredstensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';

      //then loop through hundreds
      var rightPosLeft = 83;
      var rightPosRight = 68;
      var column = 1;
      var topPos = 15;
      var topModifier = 15;

      qhtml += "<div>";
      for (let x = 0; x < hundreds; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("100token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      //then loop through tens
      var rightPosLeft = 50;
      var rightPosRight = 35;
      var column = 1;
      var topPos = 15;
      var topModifier = 15;

      qhtml += "<div>";
      for (let x = 0; x < tens; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
      //loop through ones
      var rightPosLeft = 17;
      var rightPosRight = 3;
      var column = 1;
      var topPos = 15;
      var topModifier = 15;

      qhtml += "<div>";
      for (let x = 0; x < ones; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
      //then loop through ones
    }
    else if (q.topic_key == "num42") { //place value grid 1000-9999
      let thousands = GenerateRandom(1, 8);
      let hundreds = GenerateRandom(1, 8);
      let tens = GenerateRandom(1, 8);
      let ones = GenerateRandom(1, 8);

      var correctAnswer = thousands * 1000 + hundreds * 100 + tens * 10 + ones;
      questionText = "What number is shown on in the place value grid?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1000, 9999, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

      qhtml = '<img src="' + GetImage("placetablethousandshundredsones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';

      //then loop through thousands
      var rightPosLeft = 90;
      var rightPosRight = 80;
      var column = 1;
      var topPos = 20;
      var topModifier = 18;

      qhtml += "<div>";
      for (let x = 0; x < thousands; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1000token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";

      //then loop through hundreds
      var rightPosLeft = 65;
      var rightPosRight = 55;
      var column = 1;
      var topPos = 20;
      var topModifier = 18;

      qhtml += "<div>";
      for (let x = 0; x < hundreds; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("100token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
      //then loop through tens
      var rightPosLeft = 40;
      var rightPosRight = 30;
      var column = 1;
      var topPos = 20;
      var topModifier = 18;

      qhtml += "<div>";
      for (let x = 0; x < tens; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
      //loop through ones
      var rightPosLeft = 15;
      var rightPosRight = 5;
      var column = 1;
      var topPos = 20;
      var topModifier = 18;

      qhtml += "<div>";
      for (let x = 0; x < ones; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2) {
          rightPos = rightPosRight;
          column = 1;
        } else {
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1) {
          topPos += topModifier;
        }
      }
      qhtml += "</div>";
      //then loop through ones
    }
    else if (q.topic_key == "num56") {//4 digit number from a sum
      let thousands = GenerateRandom(1, 9);
      let hundreds = GenerateRandom(1, 9);
      let tens = GenerateRandom(1, 9);
      let ones = GenerateRandom(1, 9);
      var correctAnswer = thousands * 1000 + hundreds * 100 + tens * 10 + ones;
      questionText = thousands + "x1000 + " + hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(1000, 9999, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

    }
    else if (q.topic_key == "num47") {//6 digit number from a sum
      let hundredthousands = GenerateRandom(1, 9);
      let tenthousands = GenerateRandom(1, 9);
      let thousands = GenerateRandom(1, 9);
      let hundreds = GenerateRandom(1, 9);
      let tens = GenerateRandom(1, 9);
      let ones = GenerateRandom(1, 9);
      var correctAnswer = hundredthousands * 100000 + tenthousands * 10000 + thousands * 1000 + hundreds * 100 + tens * 10 + ones;
      questionText = hundredthousands + "x100,000 + " + tenthousands + "x10,000 + " + thousands + "x1000 + " + hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";

      var usedAnswers = [];
      usedAnswers.push(correctAnswer);
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = GenerateUniqueRandom(100000, 999999, usedAnswers);
        usedAnswers.push(wrongInt);
        questionAnswers.push({ correct: false, value: wrongInt });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });

    }
    else if (q.topic_key == "num36") {
      var num1 = GenerateRandom(1, 9) * 100;
      var num2 = GenerateRandom(1, 9) * 10;
      var num3 = GenerateRandom(1, 9);
      var questionText = "What is the missing number?";
      questionText += ": " + num1.toLocaleString() + "+ _ +" + num3.toLocaleString() + " = " + (num1 + num2 + num3).toLocaleString();
      correctAnswer = num2;
      var usedAnswers = [];
      var questionAnswers = [];
      usedAnswers.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        var wrong = GenerateUniqueRandom(10, 90, usedAnswers);
        usedAnswers.push(wrong);
        questionAnswers.push({ correct: false, value: wrong });
      }
      questionAnswers.push({ correct: true, value: correctAnswer });
    } else if (q.topic_key == "num37") {
      var mult10 = [10, 100, 1000];
      var multby1 = GenerateRandom(0, 2);
      var multby2 = GenerateRandom(multby1, 2);
      var num1 = GenerateRandom(1, 10) * mult10[multby2];
      var num2 = mult10[multby1];
      var correctAnswer = num1 / num2;
      var questionText = num1.toLocaleString() + " ÷ " + num2.toLocaleString() + " =";
      var wrongInt = num1 / mult10[multby2];

      var usedAnswers = [];
      var questionAnswers = [];
      for (let i = 0; i < 3; i++) {
        wrongInt = wrongInt * 10;
        usedAnswers.push(wrongInt);
        if (wrongInt == correctAnswer) {
          questionAnswers.push({ correct: false, value: GenerateUniqueRandom(10, num1, usedAnswers) });
        } else {
          questionAnswers.push({ correct: false, value: wrongInt });
        }


      }
      questionAnswers.push({ correct: true, value: correctAnswer })
    }
    else if (q.topic_key == "num38") {
      var mult10 = [10, 100, 1000];
      var multby1 = GenerateRandom(0, 2);
      var n1 = GenerateRandom(1, 99);
      var num1 = n1 / 100;
      var num2 = mult10[GenerateRandom(0, 3)];
      var correctAnswer = num1 / num2;


      var questionText = num1.toLocaleString() + " ÷ " + num2.toLocaleString() + " =";

      var usedAnswers = [];
      var questionAnswers = [];
      num1 = num1 * num2;
      for (let i = 0; i < 3; i++) {
        num1 = num1 / 10;
        num1 = parseFloat(num1.toFixed(12));
        usedAnswers.push(num1);
        console.log(num1);
        if (num1 == correctAnswer) {
          num1 = correctAnswer / 2;
        }
        questionAnswers.push({ correct: false, value: num1.toLocaleString() });
      }
      correctAnswer = parseFloat(correctAnswer.toFixed(12));
      questionAnswers.push({ correct: true, value: correctAnswer.toString() })

    } else if (q.topic_key == "num9" && q.question_key == "Num9Q3") {
      var num1 = GenerateRandom(1, 99);
      var questionText = "What sign is missing: "
      questionText += (q.line_2.replaceAll("$", num1.toLocaleString())).toString();
      var correctAnswer = q.correct_answer;
      var questionAnswers = [];
      questionAnswers.push({ correct: true, value: correctAnswer });
      questionAnswers.push({ correct: false, value: q.wrong_answer_1 });
      questionAnswers.push({ correct: false, value: q.wrong_answer_2 });
    } else if (q.topic_key == "num17" && q.question_key == "Num17Q3") {
      var num1 = GenerateRandom(100, 990);
      var questionText = "What sign is missing: "
      questionText += (q.line_2.replaceAll("$", num1)).toString();
      var correctAnswer = q.correct_answer;
      var questionAnswers = [];
      questionAnswers.push({ correct: true, value: correctAnswer });
      questionAnswers.push({ correct: false, value: q.wrong_answer_1 });
      questionAnswers.push({ correct: false, value: q.wrong_answer_2 });
    } else if (q.topic_key == "num27" && q.question_key == "Num27Q3") {
      var num1 = GenerateRandom(1000, 9990);
      var questionText = "What sign is missing: "
      questionText += (q.line_2.replaceAll("$", num1.toLocaleString())).toString();
      var correctAnswer = q.correct_answer;
      var questionAnswers = [];
      questionAnswers.push({ correct: true, value: correctAnswer });
      questionAnswers.push({ correct: false, value: q.wrong_answer_1 });
      questionAnswers.push({ correct: false, value: q.wrong_answer_2 });
    }
    else if (q.topic_key == "num33" && q.question_key == "Num33Q3") {
      var num1 = GenerateRandom(10000, 99990);
      var questionText = "What sign is missing: "
      questionText += (q.line_2.replaceAll("$", num1.toLocaleString())).toString();
      var correctAnswer = q.correct_answer;
      var questionAnswers = [];
      questionAnswers.push({ correct: true, value: correctAnswer });
      questionAnswers.push({ correct: false, value: q.wrong_answer_1 });
      questionAnswers.push({ correct: false, value: q.wrong_answer_2 });
    } else if (q.question_key == "Num54Q1") {
      var num1 = GenerateRandom(1, 50);
      var questionText = "Is the number " + num1 + " odd or even?";

      var questionAnswers = [];
      if (num1 % 2 == 0) {//even
        var correctAnswer = "Even";
        questionAnswers.push({ correct: true, value: "Even" });
        questionAnswers.push({ correct: false, value: "Odd" });
      } else {//odd
        var correctAnswer = "Odd";
        questionAnswers.push({ correct: true, value: "Odd" });
        questionAnswers.push({ correct: false, value: "Even" });
      }
    }
    else if (q.topic_key != "num36" && q.topic_key != "num37" && q.topic_key != "num38" && q.question_key != "Num9Q3" && q.question_key != "Num17Q3" && q.question_key != "Num27Q3" && q.question_key != "Num33Q3" && q.question_key != "Num54Q1") {
      console.log("old generation system");
      //One or two base numbers to shape the rest of the generation
      var randomNumbers = [];
      if (qKeys.includes(q.question_key))
        randomNumbers = parseFormula(q.image, [0, 0]).toString().split('|');

      console.log("RAND:" + randomNumbers);
      //Fills in the question text complete with generated values
      var questionText = numberWithCommas(parseFormula(q.line_1, randomNumbers));
      if (q.line_2 !== "" && q.line_2 !== undefined)
        questionText += ": " + numberWithCommas(parseFormula(q.line_2, randomNumbers));

      //Creates an array of answers and fills in the correct answer
      var questionAnswers = [];
      var correctAnswer = parseFormula(q.correct_answer, randomNumbers);
      questionAnswers.push({ correct: true, value: correctAnswer });

      //Fills in 2-3 wrong answers, make sure they are unique
      var tempanswer = correctAnswer;
      var counter = 0;
      //while (tempanswer == correctAnswer || questionAnswers.includes(tempanswer)){
      //if ()
      //}

      questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_1, randomNumbers, questionAnswers).toLocaleString() });
      questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_2, randomNumbers, questionAnswers).toLocaleString() });
      if (q.wrong_answer_3 != undefined && q.wrong_answer_3 != "" && q.wrong_answer_3 != null)
        questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_3, randomNumbers, questionAnswers).toLocaleString() });
    }

    if (String(questionAnswers[0].value).includes(".") == false) {
      questionAnswers.forEach(element => {
        element.value = numberWithCommas(element.value);
      });
    }

    //Shuffles the answer array
    shuffleArray(questionAnswers);

    //Creates object to return
    let questionObj = {
      question: questionText,
      answers: questionAnswers,
      correct: correctAnswer,
      image: imageString,
      questionHTML: qhtml,
      topic_id: q.topic_id,
      version: "old",
      type: "MC"
    };


    return questionObj;
  }
}

export default function Practice({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const { loadedquestions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);

  const [questions, setQuestions] = useState([]);

  const [showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  const [qImage, setQImage] = useState("");
  const [qHTML, setQuestionHTML] = useState("");

  var timer = -1;
  if (props.timelimit > 0) {
    timer = props.timelimit;
  }
  else {
    timer = 60;
  }

  var questionMax = -1;
  if (props.minimum > 0) {
    questionMax = props.minimum;
  }
  //if question counter is higher than 3 then reset -refeed
  if (questionCounter > 3) {
    questionCounter = 0;
  }

  //Sets the question to a new one
  function newQuestion() {

    currQuestion = Geq(questions[Math.floor(Math.random() * questions.length)]);
    console.log(currQuestion);

    if ((currQuestion.image != "" && currQuestion.image != undefined)) {
      setQImage(require('../../assets/NumberAndPlace/Images/' + currQuestion.image + ".png"));
    } else {
      setQImage("");
    }
    if (currQuestion.questionHTML != "" && currQuestion.questionHTML != undefined) {
      setQuestionHTML(currQuestion.questionHTML);
    } else {
      setQuestionHTML("");
    }

    //Debugging
    /*
    console.log("tst: lastQ: " + lastQuestion);
    console.log("tst: currQ: " + currQuestion.question);
    console.log("tst: Counter: " + questionCounter);
    */
    return currQuestion;
  }


  function reduceTimer() {
    console.log(waitTime);
    setWaitTime(waitTime - 1);
  }

  //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
  function Reset() {
    refeedQuestions = [];
    questionCounter = 0;
    lastQuestion = "";
    console.log("RESET");
  }

  async function checkResultKeypad(value, callback) {

    //set the current question to the last question -refeed
    questionCounter = questionCounter + 1;
    lastQuestion = currQuestion.question;

    var isCorrect = true;

    if (value) {
      console.log(currQuestion.correct + " vs " + value);
      //correct answer
      var decString = "0." + value;

      var curCorrect = currQuestion.correct;
      if (curCorrect[3] == "0") {
        curCorrect = parseFloat(curCorrect).toFixed(1);
        decString = parseFloat(decString).toFixed(1);
      }
      if ((currQuestion.correct.toString().includes("0.") && curCorrect == decString) || (currQuestion.correct == value)) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
          refeedQuestions.pop();
          repeating = false;
        }
        let result;
        if (Array.isArray(currQuestion.question)) {
          result = {
            question: currQuestion.question[0].join(" "),
            correct: currQuestion.correct,
            incorrect: value
          };
        }
        else {
          result = {
            question: currQuestion.question,
            correct: currQuestion.correct,
            incorrect: value
          };
        }

        setNoFeedback([...nofeedback, result]);
      }
      //incorrect answer
      else {
        isCorrect = false;
        questionCounter = 0;
        //push question to refeed if user gets it wrong - refeed
        refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, currQuestion]);

        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }
        let result;

        if (currQuestion.correct.toString().includes("0.")) {
          if (Array.isArray(currQuestion.question)) {
            result = {
              question: currQuestion.question[0].join(" "),
              correct: currQuestion.correct,
              incorrect: "0." + value
            };

          } else {
            result = {
              question: currQuestion.question,
              correct: currQuestion.correct,
              incorrect: "0." + value
            };
          }
          setFeedback([...feedback, result]);
        }
        else {
          let result;
          if (Array.isArray(currQuestion.question)) {
            result = {
              question: currQuestion.question[0].join(" "),
              correct: currQuestion.correct,
              incorrect: value
            };
          }
          else {
            result = {
              question: currQuestion.question,
              correct: currQuestion.correct,
              incorrect: value
            };
          }
          setFeedback([...feedback, result]);
        }
      }

      if (callback) {
        await callback(isCorrect, currQuestion[1]).then(() => {
          setCurrentQuestion(newQuestion());
        });
      } else {
        setCurrentQuestion(newQuestion());
      }
    }
  }

  //Called on click
  async function checkResult(value, callback) {

    //set the current question to the last question -refeed
    questionCounter = questionCounter + 1;
    lastQuestion = currQuestion.question;
    console.log("press button");
    console.log(value);

    var isCorrect = true;
    if (value) {
      //correct answer
      if (value.correct == true) {
        setCorrectQuestions([...correctQuestions, currentQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
          refeedQuestions.pop();
          repeating = false;
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };
        setNoFeedback([...nofeedback, result]);

        newQuestion();
      }
      //incorrect answer
      else {
        questionCounter = 0;
        isCorrect = false;
        //push question to refeed if user gets it wrong - refeed
        refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }
        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();

    }
  }

  useEffect(() => {
    if (waitTime > 0) {
      var waitttimerID = setInterval(() => reduceTimer(), 1000);
      return () => {
        clearInterval(waitttimerID);
      };
    } else if (waitTime != -10) {
      setColouredFeedback(false);
      newQuestion();
    }
  }, [waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    console.log(questions);
    if (questions !== undefined && questions.length > 0) {
      console.log("Starting Game");
      var sample = newQuestion();
      setCurrentQuestion(sample);
    }
  }, [questions]);

  function AddExtraQuestions() {
    console.log("Adding Extra Questions");
    console.log(extraquestions);
    //import from CSV
    Papa.parse(extraquestions, {
      download: true,
      header: true,
      complete: function (results) {
        let test = 123;
        console.log(test);
        console.log("PROPS");
        console.log(props);
        console.log("Extra Questions:");
        console.log(results.data)
        console.log(loadedquestions);
        console.log(status);
        let addMe = [];
        //check set topics and see if in extra questions
        for (let i = 0; i < props.topicKeys.length; i++) {
          const topicKey = props.topicKeys[i];
          console.log(topicKey);
          for (let x = 0; x < results.data.length; x++) {
            const extraQ = results.data[x];
            //console.log(extraQ);
            if (extraQ.topic_key == topicKey) {
              console.log("found you")
              addMe.push(extraQ);
            }
          }
        }

        if (loadedquestions != null) {
          //if already loaded
          console.log("add loaded questions");
          for (let i = 0; i < loadedquestions.length; i++) {
            const loadedquesiton = loadedquestions[i];
            addMe.push(loadedquesiton);
          }
        }
        console.log("ALLQUESTIONS:");
        console.log(addMe);
        setQuestions(addMe);
        console.log("done adding extra questions");
      },
    });
  }

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
      AddExtraQuestions();
    }
  }, [status]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
      comboNum = 4;
    var imageName = "combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/" + imageName)
    return (require("../../assets/NumberAndPlace/Animation/" + imageName))
  }


  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionLimit={questionMax}
        onBack={() => {
          props.onBack();
          Reset();
        }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
          Reset();
        }}
      >
        <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={1720}>
            <Body>
              <div>{currQuestion !== undefined ? (


                <Container>
                  {currQuestion.type == "MC" &&
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <Question
                        type="text"
                        disabled
                        javaScriptEnabled={true}
                        //I don't know if this does anything
                        value={
                          currQuestion.question !== undefined
                            ? <div dangerouslySetInnerHTML={((currQuestion.question.replace("$", "?")))} />
                            : ""
                        }
                      >
                        <div dangerouslySetInnerHTML={{ __html: (currQuestion.question) }} />
                      </Question>
                    </div>
                  }

                  <div refreshme={currentQuestion} style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
                    {(qImage != "" && qImage != undefined && qHTML == "") &&
                      <img src={qImage}></img>
                    }

                    {qHTML != "" && currQuestion.type == "MC" && currQuestion.questionHTML != "" &&
                      <DynamicStyle >
                        <div dangerouslySetInnerHTML={{ __html: qHTML }}></div>
                      </DynamicStyle>
                    }

                  </div>

                  {currQuestion != undefined && currQuestion.type == "MC" &&
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                      }}
                    >
                      {showColouredFeedback == false && currQuestion.answers !== undefined &&
                        currQuestion.answers.map(answer => (
                          <Button
                            value={<div dangerouslySetInnerHTML={answer.value} />}
                            style={{ flex: 1, margin: "20px" }}
                            onClick={() => checkResult(answer, true)}
                          >
                            <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                          </Button>
                        ))}

                      {showColouredFeedback == true && currQuestion.answers !== undefined &&
                        currQuestion.answers.map(answer => (
                          <Button
                            value={<div dangerouslySetInnerHTML={answer.value} />}
                            style={{ flex: 1, margin: "20px", ...(answer.correct == true ? { border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)" } : { border: "2px solid #ea1d13", background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)" }) }}
                          >
                            <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                          </Button>
                        ))}
                    </div>
                  }

                  {currQuestion !== undefined && currQuestion.version == "new" && currQuestion.type == "NP" &&
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <CalculatorNew
                        scale="80%"
                        currentQuestion={currQuestion}
                        onSubmitted={checkResultKeypad}
                      />

                      {qHTML != "" && currQuestion.type == "NP" &&
                        <DynamicStyle >
                          <div dangerouslySetInnerHTML={{ __html: qHTML }}></div>
                        </DynamicStyle>
                      }
                    </div>
                  }


                </Container>

              ) : <h1></h1>}
              </div>
            </Body>
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
            width: 100%;
            height: 100%;
  background-image: url("${props => props.gameBackground}");
            background-size: cover;
            background-position: 0px -1px;
            display: flex;
            justify-content: center;
            padding-top: 100px;
          `;

const Result = styled.div`
            width: 100%;
            height: 100%;
            font-size: 5em;
            text-align: center;
            border: solid 2px #683d8c;
          `;

const Combo = styled.div`
            background: #4391bb;
            width: 120px;
            height: 120px;
            border-radius: 75px;
            border: solid #204b7b 4px;
            display: flex;
            flex-direction: column;
            text-align: center;
            color: #fff;
            justify-content: center;
            font-weight: 600;
            margin-left: 50px;
          `;

const Container = styled.div`
          width:100%
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;

const Question = styled.div`
      background: #E9E9E9;
      user-select: none;
      width: 40em;
      line-height: 35px;
      font-size: 30px;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
      padding: 20px 0px 20px;
      `;

const Button = styled.div`
            text-align: center;
            width: 5em;
            line-height: 35px;
            font-size: 3em;
      padding: 35px 0px 35px;
            margin: 5px;
            color: #fff;
            user-select: none;
            background: rgb(234, 146, 19);
            background: linear-gradient(
              0deg,
              rgba(234, 146, 19, 1) 0%,
              rgba(255, 186, 32, 1) 100%
            );
            border: 2px solid #e88f12;
            box-sizing: border-box;
            border-radius: 0.25em;
            cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
        font - size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
  }
`;

const DynamicStyle = styled.div`
text-align: center;
position: relative

img[src*="NL"], [src*="Rods"], [src*="NumberLine"], [src*="Numberline"] {
    background-color: white;
    padding: 5%; /* 5% padding for the border effect */
  }

.centered {
        position: realtive;
      top: 35%;
      //left: -15%;
      //width: 100%
      //text-align: center
      font-size 2em;
      //50%
    `;